import { Area } from 'react-easy-crop';
import { getCroppedImg } from './getCroppedImg';

export async function cropImage(
  imageSrc: string, crop: Area, rotation: number,
) {
  return getCroppedImg(imageSrc, crop, rotation);
}
